$(() => {
    // target to scroll, direction of scroll, speed, size related to the target width or height
    // (example 0.5 = 50% of target width or height)
    jQuery.fn.scrollOnClick = function(target, direction, speed, size) {
        $(this).on('mousedown', function() {
            if (direction == 'left' || direction == 'right') {
                var targetSize = parseInt($(target).width()) * size
                var cs = $(target).scrollLeft()
            } else {
                var targetSize = parseInt($(target).height()) * size
                var cs = $(target).scrollTop()
            }

            switch (direction) {
                case 'top':
                    var scrollto = cs - targetSize
                    break
                case 'bottom':
                    var scrollto = cs + targetSize
                    break
                case 'left':
                    var scrollto = cs - targetSize
                    break
                case 'right':
                    var scrollto = cs + targetSize
                    break
            }
            if (direction == 'left' || direction == 'right')
                $(target).animate({ scrollLeft: scrollto }, speed)
            else $(target).animate({ scrollTop: scrollto }, speed)

            return false
        })
    }

    $('.scrollclick').each(function() {
        var target = $(this).attr('data-target')
        var direction = $(this).attr('data-direction')
        var size = $(this).attr('data-size')
        var speed = $(this).attr('data-speed')

        if (speed == undefined) {
            speed = 500
        }
        if (size == undefined) {
            size = 1
        }

        $(this).scrollOnClick(target, direction, speed, size)
    })
})
